
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hardware/TVwall",
      function () {
        return require("private-next-pages/hardware/TVwall/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hardware/TVwall"])
      });
    }
  